
import ProductPrescriptionDropdown from '@/components/ProductPrescriptionDropdown'

export default {
  components: {
    ProductPrescriptionDropdown,
  },
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    columns: {
      type: Array,
      default: () => [],
    },
    isColoursOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasOnlyOneColumn() {
      return this.columns.length === 1
    },
  },
  methods: {
    selectOption(eyeId, option) {
      this.$emit('option-selected', { id: eyeId, option })
    },
  },
}
